import { render, staticRenderFns } from "./AuthReset.vue?vue&type=template&id=672144fe&"
import script from "./AuthReset.vue?vue&type=script&lang=js&"
export * from "./AuthReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('672144fe')) {
      api.createRecord('672144fe', component.options)
    } else {
      api.reload('672144fe', component.options)
    }
    module.hot.accept("./AuthReset.vue?vue&type=template&id=672144fe&", function () {
      api.rerender('672144fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/auth/screens/AuthReset.vue"
export default component.exports